import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKerasComponent } from './simple-icons-keras.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKerasComponent ],
    exports:      [ SimpleIconsKerasComponent ],
    bootstrap:    []
})
export class SimpleIconsKerasModule {}
